// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"258":"locale-fr","377":"locale-ru","417":"setting","467":"locale-de_ch","870":"locale-pl"}[chunkId] || chunkId) + "." + {"0":"4027abc5","112":"d2e08cdd","258":"c29944d7","377":"e6ee6524","417":"2e2e0c14","467":"f4fd8c58","626":"e5e40771","870":"f0c9e969"}[chunkId] + ".js";
};